import React from 'react';
import {
  JagadLogoWhiteWithText,
  JagadLogoColorWithBlackText,
  JagadLogoBlackWithBlackText,
  JagadLogoCircular,
} from './JagadLogo.styles';

export type JagadLogoProps = {
  type:
    | 'logo-white-text-white'
    | 'logo-color-text-black'
    | 'logo-black-text-black'
    | 'logo-circular';
  size?: number;
};

export const JagadLogo: React.FC<JagadLogoProps> = ({ type, size }) => {
  switch (type) {
    case 'logo-white-text-white':
      return <JagadLogoWhiteWithText $widthInPercent={size} />;
    case 'logo-color-text-black':
      return <JagadLogoColorWithBlackText $widthInPercent={size} />;
    case 'logo-black-text-black':
      return <JagadLogoBlackWithBlackText $widthInPercent={size} />;
    case 'logo-circular':
      return <JagadLogoCircular $widthInPercent={size} />;
  }
};

export default JagadLogo;
